module.exports = __webpack_public_path__ + "static/img/logo-inside.9e0c6aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-inside.png
// module id = x7KU
// module chunks = 1